import React from "react"
import PropTypes from "prop-types"
import { useTranslation } from "react-i18next"
import BookingSuccessModal from "./BookingSuccessModal"
import BookingSuccessActions from "./BookingSuccessActions"
import BookedOrderList from "./BookedOrderList"

// After paying: one booking shows its ID and its next steps (Figma 6058:145493); several show the
// order number, if the API gives one, and a row per booking with its own next steps.
const BookingSuccess = ({ order, onClose }) => {
  const { t } = useTranslation()
  const { orderId, bookings } = order

  if (bookings.length > 1) {
    return (
      <BookingSuccessModal isOpen idText={orderId ? t("booking_widget.success.order_id", { id: orderId }) : null} onClose={onClose}>
        <BookedOrderList bookings={bookings} />
      </BookingSuccessModal>
    )
  }

  const { booking } = bookings[0]
  return (
    <BookingSuccessModal isOpen idText={booking.bookingId ? t("booking_widget.success.booking_id", { id: booking.bookingId }) : null} onClose={onClose}>
      <BookingSuccessActions booking={booking} />
    </BookingSuccessModal>
  )
}

BookingSuccess.propTypes = {
  order: PropTypes.shape({
    orderId: PropTypes.string,
    bookings: PropTypes.arrayOf(PropTypes.shape({ key: PropTypes.string, booking: PropTypes.object.isRequired })).isRequired
  }).isRequired,
  onClose: PropTypes.func.isRequired
}

export default BookingSuccess
